import { z } from 'zod';

import {
  AccentColor,
  PercentString,
  StrategyStatus,
  Tier,
  YearMonth,
} from './primitives';

export const StrategySchema = z.object({
  id: z.string().regex(/^[a-z][a-z0-9-]*$/, 'lowercase-kebab id expected'),
  code: z
    .string()
    .regex(/^PQ-[A-Z]{3}-\d{3}$/, 'PowerQuant code format PQ-XXX-### expected'),

  name: z.string(),
  tagline: z.string().max(120),
  description: z.string().min(50),

  category: z.enum([
    'Futures',
    'Digital Assets',
    'FX',
    'Volatility',
    'Equities',
    'Fixed Income',
    'Commodities',
    'HFT',
    'Event Driven',
  ]),
  style: z.string(),
  instruments: z.array(z.string()).min(1),
  minCapital: z.number().int().positive(),

  sharpe: z.number(),
  cagr: z.number(),
  maxDD: z.number().negative(),
  winRate: z.number().min(0).max(100),
  avgHold: z.string(),
  trades: z.number().int().nonnegative(),

  inception: YearMonth,

  monthly: PercentString,
  ytd: PercentString,
  lifetime: PercentString,

  status: StrategyStatus,
  capacity: z.number().min(0).max(100),
  tier: Tier,
  color: AccentColor,

  detail: z
    .object({
      thesis: z.string(),
      mechanics: z.array(
        z.object({
          heading: z.string(),
          body: z.string(),
        }),
      ),
      sampleCodeBlock: z.string().optional(),
    })
    .optional(),
});

export type Strategy = z.infer<typeof StrategySchema>;
